import { ArrowUpRight } from "lucide-react";

export const ServiceCard = ({ icon: Icon, title, description, accent = "#1677C8", testId }) => {
  return (
    <article
      className="card-soft p-8 md:p-10 flex flex-col gap-5 h-full"
      data-testid={testId}
    >
      <div
        className="w-14 h-14 rounded-2xl inline-flex items-center justify-center"
        style={{ backgroundColor: `${accent}1A`, color: accent }}
        aria-hidden="true"
      >
        <Icon size={26} strokeWidth={2.5} />
      </div>
      <div>
        <h3 className="font-display font-semibold text-xl md:text-2xl text-[#14324A]">
          {title}
        </h3>
        <p className="mt-3 text-sm md:text-base text-[#4B6B86] leading-relaxed">
          {description}
        </p>
      </div>
    </article>
  );
};

export default ServiceCard;
